/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateOrUpdateLocationSchema } from '../models/CreateOrUpdateLocationSchema';
import type { LocationListSchema } from '../models/LocationListSchema';
import type { LocationSchema } from '../models/LocationSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LocationsApi {
    /**
     * Get Company Locations
     * Get company locations
     * @returns LocationListSchema OK
     * @throws ApiError
     */
    public static locationsGetCompanyLocationsGet({
        showDeleted,
    }: {
        showDeleted?: (boolean | null),
    }): CancelablePromise<Array<LocationListSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/locations/',
            query: {
                'show_deleted': showDeleted,
            },
        });
    }
    /**
     * Create Company Location
     * Create company location <br>Require permission: create_location
     * @returns LocationSchema Created
     * @throws ApiError
     */
    public static locationsCreateCompanyLocationPost({
        requestBody,
    }: {
        requestBody: CreateOrUpdateLocationSchema,
    }): CancelablePromise<LocationSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/locations/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Company Location
     * Get location detail
     * @returns LocationSchema OK
     * @throws ApiError
     */
    public static locationsGetCompanyLocationGet({
        locationId,
    }: {
        locationId: string,
    }): CancelablePromise<LocationSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/locations/{location_id}',
            path: {
                'location_id': locationId,
            },
        });
    }
    /**
     * Update Company Location
     * Update location <br>Require permission: update_location
     * @returns LocationSchema OK
     * @throws ApiError
     */
    public static locationsUpdateCompanyLocationPut({
        locationId,
        requestBody,
    }: {
        locationId: string,
        requestBody: CreateOrUpdateLocationSchema,
    }): CancelablePromise<LocationSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/locations/{location_id}',
            path: {
                'location_id': locationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Company Location
     * Delete location <br>Require permission: delete_location
     * @returns void
     * @throws ApiError
     */
    public static locationsDeleteCompanyLocationPost({
        locationId,
    }: {
        locationId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/locations/{location_id}',
            path: {
                'location_id': locationId,
            },
        });
    }
}
